export default {
  search: 'Search page',
  create: 'Create page',
  delete: 'Delete'
};
